"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppContext = exports.AppContext = void 0;
const react_1 = require("react");
const createStore_1 = require("./createStore");
const locales_1 = require("./locales");
const constants_1 = require("../constants");
exports.AppContext = (0, react_1.createContext)({
    defaultLang: (0, locales_1.getDomainLang)(),
    messages: constants_1.APP_MESSAGES,
    contextPaths: {},
    globalStoreHook: (0, createStore_1.createStore)({}, {}),
});
function useAppContext() {
    return (0, react_1.useContext)(exports.AppContext);
}
exports.useAppContext = useAppContext;
